import { Navigate } from 'react-router-dom';
import { resolveStorefrontEntryV3 } from '@dukanti/shared';
import { StorefrontRouteStates } from '@/features/website-templates/components/storefront-route-states';
import { TemplateLibraryScreen } from '@/features/website-templates/components/template-library-screen';
import { useStorefrontEditorData } from '@/features/website-templates/hooks/use-storefront-editor-data';
import { templateEditPath } from '@/features/website-templates/lib/template-routes';

/**
 * `/storefront` (epic #228 P3): a merchant who already has a storefront goes
 * to the edit route of the template the store opened last. Only a merchant
 * with nothing to open (no template, or an old design that could not be
 * converted) sees the template library, with the same reasons as before.
 */
export function StorefrontEntryRoute(): React.JSX.Element {
  const data = useStorefrontEditorData(null);
  if (data.status !== 'ready') return <StorefrontRouteStates data={data} />;

  const decision = resolveStorefrontEntryV3(data.state);
  if (decision.screen === 'edit') {
    return <Navigate replace to={templateEditPath(decision.templateId)} />;
  }
  return (
    <TemplateLibraryScreen
      storeId={data.storeId}
      storeSlug={data.storeSlug}
      state={data.state}
      reason={decision.reason}
    />
  );
}
